import type { IconData } from '@stacksjs/iconify-core'

export const disableHeartSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.232 2.232a2.5 2.5 0 0 1 3.536 0l3.528 3.529c4.471-2.078 10.023-1.707 14.191 1.958c.174.151.346.314.513.48c.168-.166.34-.329.513-.48c7.475-6.572 19.401-2.552 21.561 7.19c1.491 6.347-1.033 11.768-4.757 16.202a40 40 0 0 1-3.258 3.412l5.709 5.71a2.5 2.5 0 0 1-3.536 3.535l-38-38a2.5 2.5 0 0 1 0-3.536m1.202 8.823a13.3 13.3 0 0 0-1.508 3.855c-1.49 6.346 1.034 11.767 4.758 16.2c3.696 4.4 8.741 8.036 12.714 10.898l.028.02a7.84 7.84 0 0 0 9.149 0l.027-.02c1.054-.76 2.184-1.573 3.344-2.441z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default disableHeartSolid
